export const UserRole = {
	admin: "admin",
	fachverfahren: {
		admin: "fv_admin",
		manager: "fv_manager",
		designer: "fv_designer"
	}
} as const;

export const FachverfahrenBaseRoleSignificanceMap = {
	[UserRole.fachverfahren.admin]: 1,
	[UserRole.fachverfahren.manager]: 2,
	[UserRole.fachverfahren.designer]: 3
} as const satisfies Record<(typeof UserRole.fachverfahren)[keyof typeof UserRole.fachverfahren], number>;
